/* eslint-disable react/no-danger */
import React, { Component } from 'react';
import './OtherCourtInfo.less';

export class OtherCourtInfo extends Component {
  createMarkup() {
    const { otherCourtInfo } = this.props;

    const htmlStr = Array.isArray(otherCourtInfo)
      ? otherCourtInfo.map(obj => obj.html)
      : otherCourtInfo.html;

    return { __html: htmlStr };
  }

  render() {
    const { otherCourtInfo } = this.props;

    if (otherCourtInfo.empty) {
      return (<div />);
    }

    return (
      <div className="other-court-info">
        <div dangerouslySetInnerHTML={this.createMarkup()} />
      </div>
    );
  }
}

export default OtherCourtInfo;



// WEBPACK FOOTER //
// ./src/components/case/associated_cases/OtherCourtInfo.js